// Option picker dialog
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//import Avatar from '@material-ui/core/Avatar';
//import List from '@material-ui/core/List';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
//import Button from '@material-ui/core/Button';
import Option from './View';
//import box
//import PersonIcon from '@material-ui/icons/Person';
//import AddIcon from '@material-ui/icons/Add';
//import Typography from '@material-ui/core/Typography';
//import { blue } from '@material-ui/core/colors';

const useStyles = makeStyles({
	//add the other stuf
  	advancedCard : {
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
});

export default function OptionPicker(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open, items } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleClickOption = (value) => {
    onClose(value);
  };

	return (
		<Dialog onClose={handleClose} aria-labelledby="option-picker" open={open} className={classes.advancedCard}>
			<DialogTitle id="option-picker">Choose an option</DialogTitle>
			<Box className={classes.advancedContent}>
				{items.map((opt, i) => (
				<Button key={i} onClick={(e) => handleClickOption(opt)}>
					<Option id={opt.id} path={opt.pic_path} name={opt.name} key={opt.id} />
				</Button>
				))}
      		</Box>
    	</Dialog>
	);
}

/*
SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

export default function SimpleDialogDemo() {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      <Typography variant="subtitle1">Selected: {selectedValue}</Typography>
      <br />
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open simple dialog
      </Button>
      <SimpleDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
    </div>
  );
}
*/
